<template>
  <div class="fish-admin section">
    <h1 class="title">Fish</h1>

    <div class="fishes">
      <article class="fish media" v-for="fish in fishes">
        <div class="media-left">
          <img v-bind:src="fishImg(fish)" />
        </div>
        <div class="media-content">
          <h2 class="subtitle">{{fish.en}} <small><em>{{fish.la}}</em></small></h2>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import fb from 'firebase'
import fishes from '../lib/fishes'
import _ from 'underscore'

export default {
  data: function() {
    return {
      fishes: []
    }
  },
  ready: function() {
    window.fb = fb
    window.fishList = fishes
    window._ = _

    self = this
    fb.database().ref('fishes').on('child_added', function(snapshot) {
      let fish = snapshot.val()
      fish.key = snapshot.key
      self.fishes.push(fish)
    })

  },
  methods: {
    fishImg: function(fish) {
      var fishImgPath = '/static/img/fish/blue/'
      return fishImgPath + fish.en.replace(/\s+/g, '-') +
        '_' + fish.la.replace(/\s+/g, '-') +
        '.png'
    }
  }
}
</script>

<style>
.fish img { width: 100px; }
</style>



/** WEBPACK FOOTER **
 ** Fishes.vue?239fedfc
 **/